import React, { Component } from "react";
import "./Skills.css";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skills } from "../../portfolio";
import { Fade } from "react-reveal";
import DataScienceImg from "./DataScienceImg";
import FullStackImg from "./FullStackImg";
import CloudInfraImg from "./CloudInfraImg";
import DesignImg from "./DesignImg";

function GetSkillSvg(props) {
  if (props.fileName === "DataScienceImg")
    return <DataScienceImg theme={props.theme} />;
  else if (props.fileName === "FullStackImg")
    return <FullStackImg theme={props.theme} />;
  else if (props.fileName === "CloudInfraImg")
    return <CloudInfraImg theme={props.theme} />;
  return <DesignImg theme={props.theme} />;
}

class SkillSection extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div>
        {skills.data.map((skill, i) => {
          const isEven = i % 2 === 0; // 0,2,4... → image left, text right

          return (
            <div
              key={i}
              className={`skills-main-div ${!isEven ? "reverse-skill" : ""}`}
            >
              {/* Image side */}
              <Fade
                duration={2000}
                {...(isEven ? { left: true } : { right: true })}
              >
                <div className="skills-image-div">
                  <GetSkillSvg fileName={skill.fileName} theme={theme} />
                </div>
              </Fade>

              {/* Text side */}
              <div className="skills-text-div">
                <Fade
                  duration={1000}
                  {...(isEven ? { right: true } : { left: true })}
                >
                  <h1 className="skills-heading" style={{ color: theme.text }}>
                    {skill.title}
                  </h1>
                </Fade>

                <Fade
                  duration={1500}
                  {...(isEven ? { right: true } : { left: true })}
                >
                  <SoftwareSkill logos={skill.softwareSkills} />
                </Fade>

                <Fade
                  duration={2000}
                  {...(isEven ? { right: true } : { left: true })}
                >
                  <div>
                    {skill.skills.map((skillSentence, idx) => (
                      <p
                        key={idx}
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                      >
                        {skillSentence}
                      </p>
                    ))}
                  </div>
                </Fade>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SkillSection;
